import { InteractionRequiredAuthError, SilentRequest } from "@azure/msal-browser";
import { IPublicClientApplication } from "@azure/msal-browser";

export interface KnopReactApp {
  acquireToken: () => Promise<string | null>;
}

/**
 * This class is used to obtain an MSAL/Azure AD token.
 */
export class KnopReact implements KnopReactApp {
  constructor(
    protected readonly msalInstance: IPublicClientApplication,
    protected readonly azureAdScope: string,
  ) {}

  async acquireToken(): Promise<string> {
    const msalInstance = this.msalInstance;

    const activeAccount = msalInstance.getActiveAccount();
    const accounts = msalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
      // User is not signed in.
      throw new InteractionRequiredAuthError();
    }

    const request: SilentRequest = {
      scopes: [this.azureAdScope],
      account: activeAccount ?? accounts[0],
    };

    try {
      const authResult = await msalInstance.acquireTokenSilent(request);

      return authResult.accessToken;
    } catch (error) {
      // https://learn.microsoft.com/en-us/entra/identity-platform/msal-error-handling-js
      if (error instanceof InteractionRequiredAuthError) {
        // extract, if exists, claims from the error object
        if (error.claims) {
          request.claims = error.claims;
        }

        // call acquireTokenPopup in case of InteractionRequiredAuthError failure
        const accessTokenResponse = await msalInstance.acquireTokenPopup(request);
        return accessTokenResponse.accessToken;
      }

      // if the error is not an instance of InteractionRequiredAuthError, throw it.
      console.error("An error occurred while acquiring the token: ", error);
      throw error;
    }
  }
}
